import { switchMap } from 'rxjs/operators';
import { of, map, take, Observable } from 'rxjs';

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { AuthService } from '@/app/core/services/auth/auth.service';

export const ProfileGuard: CanMatchFn = (): Observable<boolean> => {
  const authService = inject(AuthService);

  return of(authService.user()).pipe(
    take(1),

    switchMap((user) => {
      if (user) {
        return of(user);
      }

      return authService.loadProfile();
    }),

    map(() => {
      authService.setUserLoaded(true);

      return true;
    }),
  );
};
